import { FlowTabVertical } from '@shared/components/FlowTabView/FlowTabVertical';
import { FlowTabVerticalList } from '@shared/components/FlowTabView/FlowTabVerticalList';
import {
    FlowTab,
    FlowTabProps,
} from '@shared/components/FlowTabView/FlowTabView';
import useLangText from '@shared/hooks/useLangText';
import { LayoutBuilderTypeFull, ServiceVM } from '@shared/types/process';
import { LayoutBloc } from '../LayoutBloc';

interface Props extends Omit<FlowTabProps, 'items'> {
    block: LayoutBuilderTypeFull;
    flowTabType?: 'horizontal' | 'vertical' | 'verticalList';
    isReadOnly?: boolean;
    service?: ServiceVM;
    classNameWrapper?: string;
}

export const BlockViewTab = ({
    block,
    isReadOnly,
    service,
    tabProps,
    flowTabType = 'horizontal',
    classNameWrapper,
    ...props
}: Props) => {
    const getLangText = useLangText();
    let FlowTabComponent = FlowTab;

    switch (flowTabType) {
        case 'vertical':
            FlowTabComponent = FlowTabVertical;
            break;
        case 'verticalList':
            FlowTabComponent = FlowTabVerticalList;
            break;
        default:
            FlowTabComponent = FlowTab;
    }

    return (
        <>
            <FlowTabComponent
                {...props}
                tabProps={tabProps}
                items={block.children
                    .filter((item) => item.type === 'TabItem')
                    .sort((a, b) => a.options?.order - b.options?.order)
                    .map((item) => {
                        return {
                            key: item.id.toString(),
                            children: (
                                <LayoutBloc
                                    block={item}
                                    classNameWrapper={classNameWrapper}
                                    flowTabType={flowTabType}
                                    isReadOnly={isReadOnly}
                                    service={service}
                                    tabProps={tabProps}
                                />
                            ),
                            label: getLangText(item?.options?.tabLabel),
                            data: item,
                        };
                    })}
            />
        </>
    );
};
